/**
 * Shared Summary row value helpers for repeatable instance steps (#1154 / #996).
 */

type RepeatableInstanceNameStatusRecord = {
  name?: string | null;
  status?: string | null;
};

export function repeatableInstanceNameTypeRowValue(
  unit: RepeatableInstanceNameStatusRecord,
  dataField: string,
): string | number | boolean | null | undefined {
  if (dataField === 'name') {
    return unit.name ?? '';
  }
  if (dataField === 'status') {
    return unit.status === 'existing' ? 'Existing' : 'New';
  }
  return undefined;
}
